import lodash from "lodash";
import { defineAsyncComponent, reactive } from "vue";
import { addModal } from "../../../../app.logic";
import i18n from "../../../../i18n";
import { modalStyleForm } from "../../../../utils/constant";
import { createLoading } from "../../../../utils/loading";
import { createPage } from "../../../../utils/page";
import { validateError } from "../../../../utils/validate";
import { callSearch, createColumns as createCountryColumns } from "./country-request.logic";
const CountryForm = defineAsyncComponent(() => import("./CountryRequestForm"));

export const actionPrefix = "resource/v1/master/country";
export const { isLoading, setIsLoading } = createLoading();

export const createColumns = ({ props, data }) => {
    const { visibleParent } = props;
    const columns = createCountryColumns({ data });
    if (!visibleParent) {
        lodash.remove(columns, d => d.dataIndex?.includes("url"));
        lodash.remove(columns, d => d.dataIndex?.includes("refAttach"));
    }
    return columns;
};

export const openModalForm = ({ props, items }) => {
    const { useForm } = props;
    useForm
        .validate()
        .then(() => {
            const refs = reactive({ form: null });
            const options = addModal({
                bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
                    okButtonProps: { disabled: props.viewOnly },
                    header: i18n.global.t("model.country.children"),
                    onOk: () => {
                        refs.form.callOnClickModalOk().then(record => {
                            if (items) {
                                items.push(record);
                            } else {
                                lodash.merge(props.form, record);
                            }
                            options.bind.onCancel();
                        });
                    }
                }),
                render: () => (
                    <CountryForm
                        ref={e => {
                            if (e) refs.form = e;
                        }}
                        {...props}
                    ></CountryForm>
                )
            });
            return options;
        })
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const initData = ({ props, data }) => {
    const { /* menuContext, */ viewOnly, parent /* , useForm */ } = props;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: parent.children, options: { sort: [{ name: "name", type: "ASC" }] } });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        /*
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) => onClickActiveAll({ rowSelection, callActiveAll, state: data, onSearch, setIsLoading })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) => onClickArchiveAll({ rowSelection, callArchiveAll, state: data, onSearch, setIsLoading })
        }),
        createManageExportCsv({ menuContext })
        */
    ];
    data.manageExtras = [];
    data.rowActions = [];
    if (!viewOnly) {
        /*
        data.manageExtras.push({
            render: () => ({
                ...createButtonCreate({
                    onClick: () =>
                        openModalForm({
                            props: { menuContext, viewOnly, setAppPageHeader: false, form: {}, parent, useForm },
                            items: props.parent.children
                        }),
                    options: { text: i18n.global.t("model.country.children") }
                })
            }),
            visible: () => has({ menuContext, key: "canCreate" })
        });
        data.rowActions.push(
            createRowActionEdit({
                menuContext,
                onClick: ({ record }) =>
                    openModalForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record, visibleChildren: false, useForm } })
            })
        );
        */
    } else {
        /*
        data.rowActions.push(
            createRowActionView({
                menuContext,
                onClick: ({ record }) =>
                    openModalForm({ props: { menuContext, viewOnly, setAppPageHeader: false, form: record, visibleChildren: false, useForm } })
            })
        );
        */
    }

    fetchData({ props, data }).then(page => props.parent.children.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria) {
        return Promise.resolve({ data: [] });
    }
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
